<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalEditarMacro">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Adicionar Macro</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">
                
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Data Hora:</label><br>
                    <input-data-hora-picker v-model="macro.dataHora" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Motivo:</label><br>
                    <select class="pula form-control" v-model="macro.macro">
                      <option value="0">01 - INICIO JORNADA</option>
                      <option value="1">02 - FIM JORNADA</option>
                      <option value="2">03 - ESPERA</option>
                      <option value="3">04 - ALIMENTACAO</option>
                      <option value="4">05 - DESCANSO DIRECAO</option>
                      <option value="5">06 - ABASTECIMENTO</option>
                      <option value="6">07 - FISCALIZACAO</option>
                      <option value="7">08 - MANUTECAO</option>
                      <option value="20">21 - EMBARQUE</option>
                      <option value="21">22 - DESEMBARQUE</option>
                      <option value="33">34 - EM ATIVIDADE</option>
                      <option value="50">51 - TEXTO</option>
                      <option value="100">101 - MOVIMENTO</option>
                    </select>
                  </div>
                </div>       
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Motorista:</label><br>
                    <input id="motoristaId" type="hidden" class="form-control" v-model="macro.motoristaId">
                    <buscar-lista-motorista  id="motoristaNome" placeholder="Selecione um motorista.." v-model="macro.motoristaNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarMotorista" :on-blur="verificarMotorista" />
                  </div>
                </div>
                
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Veículo:</label><br>
                    <input id="veiculoId" type="hidden" class="form-control" v-model="macro.veiculoId">
                    <buscar-veiculo type="search" id="veiculoDescricao" placeholder="Selecione um veículo.." v-model="macro.veiculoDescricao" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarVeiculo" :on-blur="verificarVeiculo" />
                  </div>
                </div>
                
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="adicionarMacro"><i v-if="botaoProcessando" class="fa fa-spinner fa-spin"></i> Gerar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalEditarMacro = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="col-md-12">
            <div class="row row-margin">
              <div class="col-md-12">
                <strong>Periodo: </strong> De: {{dadosAnalise.dataInicial}} até {{dadosAnalise.dataFinal}}
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-6">
                <strong>Veículo: </strong> {{dadosAnalise.veiculo}}
              </div>
              <div class="col-md-6">
                <strong>Empresa: </strong>{{dadosAnalise.empresa}}
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-4">
                <strong>Distância Percorrida: </strong>{{parseFloat(dadosAnalise.kmRodados).toFixed(2)}} Km 
              </div>
              <div class="col-md-4">
                <strong>Velocidade Média: </strong>{{parseFloat(dadosAnalise.velocidadeMedia).toFixed(2)}} Km/h
              </div>
                <div class="col-md-4">
                <strong>Velocidade Máxima: </strong>{{parseFloat(dadosAnalise.velocidadeMaxima).toFixed(2)}} Km/h 
              </div>
            </div>
            <div class="row row-margin">
              <div class="col-md-4">
                
              </div>
              <div class="col-md-4">
                
              </div>
              <div class="col-md-4">
                <strong>Motorista: </strong>{{dadosAnalise.motorista}}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row row-margin">
              <div class="col-md-4">
                <div>
                  <strong>Problemas encontrados na Análise</strong>
                  <div class="description" v-html="dadosAnaliseProblemas"></div>
                </div>
              </div>
              <div class="col-md-4">
              </div>
              <div class="col-md-4">
                <div class="pull-right">
                  <input id="botaoMudarMotivo" class="btn btn-primary" type="submit" value="Adicionar Macro" v-on:click="showModalEditarMacro = true">
                  <router-link class="btn btn-warning" to="/analiseJornadaTabela">
                    <span class="glyphicon glyphicon-back"></span> Salvar
                  </router-link> 
                  
                  <button id="gravarAnalise" type="button" class="btn btn-success " v-on:click="gravarAnalise" >
                    <span class="glyphicon glyphicon-save" aria-hidden="true"></span> Gravar Análise
                  </button>

                </div>
              </div>
            </div>
          </div>

          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>HORA</th>
                <th>MACRO</th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in dadosAnaliseMacros" >
              <tr>
                <td>{{grid.dataHoraInicio}}</td>
                <td>{{grid.macro}}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>PERIODO</th>
                <th>DURAÇÃO</th>
                <th></th>
                <th>MOTIVO</th>
                <th>TIPO</th>
                <th>OBSERVAÇÃO</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in dadosAnalise.dados" >
              <template v-if="i > 0 && dadosAnalise.dados[i].data !== dadosAnalise.dados[i-1].data">
                <tr style="background-color: #FF0400; height: 20px"><td colspan="6"></td></tr>
              </template>
              <tr v-bind:class="{ 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }">
                <td width="140">
                  <small>
                    <template v-if="grid.dataHoraInicialViagem">
                      <span class="text-success">
                        <strong>
                          {{grid.data}} 
                          {{grid.dataHoraInicio}}
                        </strong>
                      </span>
                    </template>
                    <template v-else>
                      {{grid.data}} 
                      {{grid.dataHoraInicio}}
                    </template>
                    <br>
                    <template v-if="grid.dataHoraFinalViagem">
                      <span class="text-danger">
                        <strong>
                          {{grid.data}} 
                          {{grid.dataHoraFinal}}
                        </strong>
                      </span>
                    </template>
                    <template v-else>
                      {{grid.data}} 
                      {{grid.dataHoraFinal}}
                    </template>
                  </small>
                </td>
                <td width="85"><small>{{grid.dataHoraDuracao}}</small></td>
                <td><small>{{grid.statusVeiculo}}</small>
                  <template v-if="grid.statusVeiculo === 'VEICULO EM MOVIMENTO'">
                    <small> - {{formatarVelocidadeMetros(grid.kmRodados)}} metros </small>
                  </template>
                </td>
                <td><small>{{grid.motivo}}</small></td>
                <td><small>{{grid.tipoMotivo}}</small></td>
                <!-- <td>{{grid.movimentoSecundario}}</td> -->
                <td><small class="text-muted">{{grid.observacao}}</small></td>

                <td>
                  <!-- <template v-if="grid.tipoMotivo == 'Macro'">
                    <img v-tooltip="'Editar'" v-on:click="editarMacro(grid.id)" src="/static/images/editar.png" />
                  </template> -->
                </td>
                <td>
                  <!-- <template v-if="grid.tipoMotivo == 'Macro'">
                    <img v-tooltip="'Deletar'" v-on:click="deletarMacro(grid.id)" src="/static/images/deletar.png" />
                  </template> -->
                </td>
                <!-- <td>{{latitude}}</td>
                <td>{{longitude}}</td>
                <td>{{icone}}</td>
                <td>{{kmRodados}}</td>
                <td>{{velocidadeMaxima}}</td>
                <td>{{velocidadeMedia}}</td>
                <td>{{alerta}}</td>
                <td>{{error}}</td>
                <td>{{automatico}}</td>
                <td>{{mudouDia}}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      macro: {
        id: '0',
        dataHora: '',
        serial: '',
        latitude: 0,
        longitude: 0,
        macro: '',
        macroTexto: '',
        motoristaId: 0,
        motoristaNome: '',
        veiculoId: 0,
        veiculoDescricao: '',
        bateria: '',
        mac: '',
        tipoTextoLivre: '',
        textoLivre: ''
      },
      botaoProcessando: false,
      showModalEditarMacro: false,
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      inicioJornadaManual: false,
      finalJornadaManual: false,
      dataHoraInicialJornadaManual: '',
      dataHoraFinalJornadaManual: '',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosAnalise: [],
      dadosAnaliseMacros: [],
      dadosAnaliseProblemas: '',
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    }
  },
  mounted () {
    // this.buscarVeiculos()
    this.gerarAnalise()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    gerarAnalise: function () {
      var self = this
      self.processando = true
      var jornadaMacroId = this.$route.params.jornadaMacroId
      var dataHoraInicial = this.$route.params.dataInicial
      var dataHoraFinal = this.$route.params.dataFinal
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/v2/gestaoJornadas/gerarJornadaMacros?jornadaMacroId=' + jornadaMacroId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosAnalise = dadosCadastro
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados
        self.processando = false
      })
    },
    gravarAnalise: function () {
      var self = this
      var jornadaMacroId = this.$route.params.jornadaMacroId
      var dataHoraInicial = this.$route.params.dataInicial
      var dataHoraFinal = this.$route.params.dataFinal
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      self.processando = true
      var url = '/api/v2/gestaoJornadas/gerarJornadaMacrosGravar?jornadaMacroId=' + jornadaMacroId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosAnalise = dadosCadastro
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados
        self.processando = false
        self.$router.replace('/gestaoJornada')
      })
    },
    editarMacro: function (macroId) {
      let self = this
      self.buscarMacro(macroId)
      self.showModalEditarMacro = true
    },
    buscarMacro: function (macroId) {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/v2/gestaoJornadas/' + macroId
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        self.processando = false
        var dados = response.data
        self.macro.id = dados.id
        self.macro.dataHora = dados.dataHora
        self.macro.serial = dados.serial
        self.macro.latitude = dados.latitude
        self.macro.longitude = dados.longitude
        self.macro.macro = dados.macro
        self.macro.macroTexto = dados.macroTexto
        self.macro.motoristaId = dados.motoristaId
        self.macro.motoristaNome = dados.motoristaNome
        self.macro.veiculoId = dados.veiculoId
        self.macro.veiculoDescricao = dados.veiculoDescricao
        self.macro.bateria = dados.bateria
        self.macro.mac = dados.mac
        self.macro.tipoTextoLivre = dados.tipoTextoLivre
        self.macro.textoLivre = dados.textoLivre
        console.log(self.macro)
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    deletarMacro: function (id) {
      let self = this
      let message = 'Deseja realmente deletar essa Macro?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/api/v2/gestaoJornadas/' + id
          axios.delete(url, config)
          .then(function (response) {
            console.log(response)
            if (response.status === 200) {
              self.$toastr('success', 'Macro deletada com sucesso.', 'Atenção')
              self.gerarAnalise()
              dialog.close()
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção')
              dialog.close()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    setarMotorista: function (motorista) {
      this.macro.motoristaId = motorista.id
      this.macro.motoristaNome = motorista.nome
      $(this.$el).find('#motoristaNome').val(motorista.nome)
    },
    verificarMotorista: function () {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.macro.motoristaId = 0
        this.macro.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.macro.motoristaId = 0
        this.macro.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
    },
    setarVeiculo: function (veiculo) {
      this.macro.veiculoId = veiculo.id
      this.macro.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculo: function () {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.macro.veiculoId = 0
        this.macro.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.macro.veiculoId = 0
        this.macro.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
    },
    adicionarMacro: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      let url = ''
      if (self.macro.id === 0) {
        url = '/api/v2/gestaoJornadas/salvar'
        axios.post(url, JSON.stringify(self.macro), config)
        .then(function (response) {
          console.log(response)
          if (response.status === 201) {
            self.processando = false
            self.gerarAnalise()
            self.showModalEditarMacro = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        url = '/api/v2/gestaoJornadas/editar'
        axios.put(url, JSON.stringify(self.macro), config)
        .then(function (response) {
          console.log(response)
          if (response.status === 200) {
            self.processando = false
            self.gerarAnalise()
            self.showModalEditarMacro = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/jornadastabelas/AnaliseJornadaTabelaVisualizar.vue